// components/Portal.js
//
// Renders its children into document.body.
//
// Every popup on the create form is `position: fixed; inset: 0`, which is
// supposed to mean "the viewport". It does not when an ancestor has a
// `backdrop-filter`, `filter` or `transform`: that ancestor becomes the
// containing block for fixed descendants AND their stacking context. Every
// `.section-card` has a backdrop-filter, so a sheet rendered inside one was
// sized to the card and painted under the cards after it - the event type,
// date and time pickers opened "behind" the rest of the form, whatever their
// z-index. The venue search never had the problem only because it is
// rendered at the page root. A portal puts every sheet there.
import { createPortal } from 'react-dom';

export default function Portal({ children }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
